import React, { useState, useEffect } from "react";
import { Row, Col, Container, Button, Collapse } from "reactstrap";
import styled from "styled-components";
import { RebelColors,
        RebelButton,
        RebelAccentButton,
        RebelSecondaryButton,
        RebelDangerButton,
        RebelModal,
        RebelModalHeader,
        RebelModalBody,
        RebelModalFooter} from "../../../../styles/rebel-experiences";
import { BoldLabel,
        Spacer,
        UnderlineButton,
        transportationOptions,
        currencyOptions} from "../../../../utils/budget-tool-specific";
import CostSummary from "../cost-summary/rebel-cost-summary-output";
import { validateExperienceForm } from "../../../budget/common/helper";
import { listenToDocumentProperty, updateDocumentProperty, deleteNestedDocumentProperty, deleteNestedDocumentProperty3, listenToCollection } from "../../../../utils/firestore-functions";
import { GetDB, generateGUID } from "../../../../utils/database/firebase-budget-tool";
import RebelMiscellaneousInputs from "../components/rebel-miscellaneous-inputs";
import RebelFormInput from "../components/rebel-form-input";
import RebelFormInputIndex from "../components/rebel-form-input-index";
import RebelFormInputExperienceMulti from "../components/rebel-form-input-exp-multi";
import RebelFormInputPP from "../components/rebel-form-input-pp";
import FormInputExchange from "../../budget-tool/input-components/form-input-exp-exchange";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy, arrayMove } from '@dnd-kit/sortable';
import { RebelSortableItem } from "../components/rebel-sortable-item";
import FormInput from "../../budget-tool/input-components/form-input";
import firebase from "firebase/compat/app";

const RebelExperienceInputFormTab = (props) => {
    const [costInputOpen, setCostInputOpen] = useState(true);
    const [villaList, setVillaList] = useState([]);
    const [agendaId, setAgendaId] = useState(null);

    const budgetDB = GetDB();
    const [expData, setExpData] = useState(
        {
            title: {value: props.experience[1].title, invalid: false, required: true},
            index: props.experience[1].index ? props.experience[1].index : 0,
            notes: props.experience[1].notes ? props.experience[1].notes : "",
            villaId: {value: props.experience[1].villaId || "", invalid: false, required: false},
            villaName: {value: props.experience[1].villaName || "", invalid: false, required: false},
            villaRentalFee: {value: props.experience[1].villaRentalFee || 0, invalid: false, required: true},
            cleaningFee: {value: props.experience[1].cleaningFee || 0, invalid: false, required: true},
            destCurrency: {value: props.experience[1].destCurrency, invalid: false, required: true},
            base: {value: props.experience[1].base, invalid: false, required: true},
            convert: {value: props.experience[1].convert, invalid: false, required: true},
            location: {value: props.experience[1].location, invalid: false, required: true},
            flightCost: {value: props.experience[1].flightCost, invalid: false, required: true},
            costPerTransportation: {value: props.experience[1].costPerTransportation, invalid: false, required: true},
            transportation: {value: props.experience[1].transportation || [], invalid: false, required: true},
            costPerActivity: {value: props.experience[1].costPerActivity, invalid: false, required: true},
            numActivities: {value: props.experience[1].numActivities, invalid: false, required: true},
            costPerBreakfast: {value: props.experience[1].costPerBreakfast, invalid: false, required: true},
            numBreakfast: {value: props.experience[1].numBreakfast, invalid: false, required: true},
            costPerLunch: {value: props.experience[1].costPerLunch, invalid: false, required: true},
            numLunch: {value: props.experience[1].numLunch, invalid: false, required: true},
            costPerDinner: {value: props.experience[1].costPerDinner, invalid: false, required: true},
            numDinner: {value: props.experience[1].numDinner, invalid: false, required: true},
            costPerAlcohol: {value: props.experience[1].costPerAlcohol, invalid: false, required: true},
            numAlcohol: {value: props.experience[1].numAlcohol, invalid: false, required: true},
            roomRental: {value: props.experience[1].roomRental, invalid: false, required: true},
            av: {value: props.experience[1].av, invalid: false, required: true},
            setupFee: {value: props.experience[1].setupFee, invalid: false, required: true},
            numMeetings: {value: props.experience[1].numMeetings, invalid: false, required: true},
            costPerCoffee: {value: props.experience[1].costPerCoffee, invalid: false, required: true},
            numCoffee: {value: props.experience[1].numCoffee, invalid: false, required: true},
            miscellaneousCosts: {value: [], invalid: false, required: true},
            distanceFromAirport: {value: props.experience[1].distanceFromAirport || "", invalid: false, required: false},
            numberOfBedrooms: {value: props.experience[1].numberOfBedrooms || 0, invalid: false, required: false},
            villaURL: {value: props.experience[1].villaURL || "", invalid: false, required: false},
            nearestCity: {value: props.experience[1].nearestCity || "", invalid: false, required: false},
            distanceToCity: {value: props.experience[1].distanceToCity || "", invalid: false, required: false},
        })

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {
            const oldIndex = expData.miscellaneousCosts.value.findIndex(item => item.id === active.id);
            const newIndex = expData.miscellaneousCosts.value.findIndex(item => item.id === over.id);

            let newData = {...expData};
            newData.miscellaneousCosts.value = arrayMove(newData.miscellaneousCosts.value, oldIndex, newIndex);
            setExpData(newData);
        }
    }

    useEffect(() => {
        var unsubscribe = listenToDocumentProperty(budgetDB, "rebelExperienceGuides", props.guideid, "experiences", setMiscCost);
        return unsubscribe;
    },[]);

    useEffect(() => {
        var unsubscribe = listenToCollection(budgetDB, "rebelVillas", setVillaList);
        return unsubscribe;
    }, []);

    // Listen for agendaId on the guide
    useEffect(() => {
        const unsubscribe = listenToDocumentProperty(
            budgetDB,
            "rebelExperienceGuides",
            props.guideid,
            "agendaId",
            (value) => setAgendaId(value || null)
        );
        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [props.guideid]);

    // Sync agenda with current villa IDs from all experiences
    const syncAgendaProperties = (updatedExperiences) => {
        if (!agendaId) return;

        // Get all villa IDs from experiences
        const villaIds = Object.values(updatedExperiences || {})
            .filter(exp => exp.villaId)
            .map(exp => exp.villaId);

        // Read current agenda to preserve existing blocks
        budgetDB.collection("agenda-saved-agendas").doc(agendaId).get()
            .then((doc) => {
                if (!doc.exists) return;

                const currentAgenda = doc.data();
                const currentBlocks = currentAgenda.blocksPerLocation || {};

                // Build new blocksPerLocation, preserving existing blocks for villas that still exist
                const newBlocksPerLocation = {};
                villaIds.forEach(id => {
                    newBlocksPerLocation[id] = currentBlocks[id] || [];
                });

                // Update the agenda
                budgetDB.collection("agenda-saved-agendas").doc(agendaId).update({
                    blocksPerLocation: newBlocksPerLocation,
                    selectedLocationIds: villaIds,
                    updatedAt: new Date().toISOString()
                });
            })
            .catch((error) => {
                console.error('Error syncing agenda properties:', error);
            });
    };

    useEffect(() => {
        if (props.setSaveRetreatCostsRef) {
            props.setSaveRetreatCostsRef(saveRetreatCosts);
        }
    }, [expData]);

    const setMiscCost = (property) => {
        let newData = {...expData};

        if (property[props.experience[1].id]) {
            newData.miscellaneousCosts.value = property[props.experience[1].id]["miscellaneousCosts"];
            newData.notes = property[props.experience[1].id]["notes"];
            setExpData(newData);
        }
    }

    let data = {
        title: expData.title.value,
        location: expData.location.value,
        destCurrency: expData.destCurrency.value,
        base: expData.base.value,
        convert: expData.convert.value,
        timeCreated: props.experience[1].timeCreated,
        id: props.experience[1].id,
        villaId: expData.villaId.value,
        villaName: expData.villaName.value,
        villaRentalFee: expData.villaRentalFee.value,
        cleaningFee: expData.cleaningFee.value,
        flightCost: expData.flightCost.value,
        costPerTransportation: expData.costPerTransportation.value,
        transportation: expData.transportation.value,
        costPerActivity: expData.costPerActivity.value,
        numActivities: expData.numActivities.value,
        costPerBreakfast: expData.costPerBreakfast.value,
        numBreakfast: expData.numBreakfast.value,
        costPerLunch: expData.costPerLunch.value,
        numLunch: expData.numLunch.value,
        costPerDinner: expData.costPerDinner.value,
        numDinner: expData.numDinner.value,
        costPerCoffee: expData.costPerCoffee.value,
        numCoffee: expData.numCoffee.value,
        costPerAlcohol: expData.costPerAlcohol.value,
        numAlcohol: expData.numAlcohol.value,
        setupFee: expData.setupFee.value,
        roomRental: expData.roomRental.value,
        av: expData.av.value,
        numMeetings: expData.numMeetings.value,
        miscellaneousCosts: expData.miscellaneousCosts.value,
        index: expData.index ? expData.index : 0,
        notes: expData.notes ? expData.notes : "",
        distanceFromAirport: expData.distanceFromAirport.value,
        numberOfBedrooms: expData.numberOfBedrooms.value,
        villaURL: expData.villaURL.value,
        nearestCity: expData.nearestCity.value,
        distanceToCity: expData.distanceToCity.value,
    }

    const [displaySummary, setDisplaySummary] = useState(props.client);
    const [savedModal, setSavedModal] = useState(false);
    const [failedModal, setFailedModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteID, setDeleteID] = useState("");

    const [refresh, setRefresh] = useState(true);

    const toggleSavedModal = ( ) => { console.log("success"); setSavedModal(!savedModal) };
    const toggleFailedModal = ( ) => { setFailedModal(!failedModal) };

    const saveRetreatCosts = () => {

        if (validateExperienceForm( )) {
            //update document property
            updateDocumentProperty( budgetDB, "rebelExperienceGuides", props.guideid, "experiences."+ props.experience[1].id, data, () => {
                toggleSavedModal();
                // Sync agenda with updated experiences
                const updatedExperiences = {
                    ...props.guideData.experiences.value,
                    [props.experience[1].id]: {
                        ...props.guideData.experiences.value[props.experience[1].id],
                        villaId: expData.villaId.value
                    }
                };
                syncAgendaProperties(updatedExperiences);
            }, toggleFailedModal);
            props.updateGuideDetails(props.guideid);
        } else {
            toggleFailedModal();
        }
    }

    const removeConversionWhenSwitchingCurrency = (newData, guideData) => {
        if (newData.destCurrency.value === guideData.currency.value) {
            newData.base.value = 1;
            newData.convert.value = 1;
        }
    }

    const addMiscellaneousCost = () => {
        let newData = {
            title: "",
            cost: 0,
            pp: "per person",
            id: generateGUID(),
        }

        let newMiscCost = [...expData.miscellaneousCosts.value];
        newMiscCost.push(newData);

        let newExpData = {...expData};
        newExpData.miscellaneousCosts.value = newMiscCost;
        setExpData(newExpData);

    }

    const deleteMiscCost = (miscID) => {
        let newExpData = {...expData};
        newExpData.miscellaneousCosts.value = newExpData.miscellaneousCosts.value.filter((key) => key.id !== miscID);
        setExpData(newExpData);
    };

    const handleMiscellaneousChange = (value, id, type) => {

        let miscCost = [...expData.miscellaneousCosts.value];
        let index = miscCost.findIndex(p => p.id == id);
        if (type === "title") {
            miscCost[index].title = value;
        } else if (type === "cost") {
            miscCost[index].cost = value;
        } else if (type === "pp") {
            if (value === "per person") {
                miscCost[index].pp = "per trip";
            } else {
                miscCost[index].pp = "per person";
            }
        }

        let newExpData = {...expData};
        newExpData.miscellaneousCosts.value = miscCost;
        setExpData(newExpData);
    }

    const deleteExperience = (id) => {
        deleteNestedDocumentProperty(budgetDB, "rebelExperienceGuides", props.guideid,  "experiences", props.experience[1].id)
            .then(() => {
                // Sync agenda with remaining experiences (exclude the deleted one)
                const remainingExperiences = { ...props.guideData.experiences.value };
                delete remainingExperiences[props.experience[1].id];
                syncAgendaProperties(remainingExperiences);
            });
        setDeleteModal(false);
        props.setTabKey(0);
    };

    const cloneVacation = () => {
        let newData = {...props.experience[1]};
        newData.title = newData.title + " (copy)";
        newData.index = newData.index + 1;
        createNewExperience(newData);
    }

    const createNewExperience = (experienceData) => {
        const timeStamp = firebase.firestore.Timestamp.now()
        const newID = generateGUID();
        experienceData.timeCreated = timeStamp;
        experienceData.id = newID;
        updateDocumentProperty(budgetDB, "rebelExperienceGuides", props.guideid, "experiences." + newID, experienceData);
    }

    const confirmDelete = (id) => {
        setDeleteModal(true);
        setDeleteID(id);
    }

    const handleVillaSelection = (villaId) => {
        if (!villaId) return;

        const villa = villaList.find(v => v.id === villaId);
        if (!villa) return;

        let newData = {...expData};

        // Auto-populate all fields from villa data
        newData.villaId.value = villaId;
        newData.villaName.value = villa.villaName || "";
        newData.title.value = villa.villaName || "";
        newData.location.value = villa.location || "";
        newData.destCurrency.value = villa.destCurrency || "";
        newData.base.value = villa.base || 1;
        newData.convert.value = villa.convert || 1;
        newData.villaRentalFee.value = villa.villaRentalFee || 0;
        newData.cleaningFee.value = villa.cleaningFee || 0;
        newData.flightCost.value = villa.flightCost || 0;
        newData.costPerTransportation.value = villa.costPerTransportation || 0;
        newData.transportation.value = villa.transportation || [];
        newData.costPerActivity.value = villa.costPerActivity || 0;
        newData.numActivities.value = villa.numActivities || 0;
        newData.costPerBreakfast.value = villa.costPerBreakfast || 0;
        newData.numBreakfast.value = villa.numBreakfast || 0;
        newData.costPerLunch.value = villa.costPerLunch || 0;
        newData.numLunch.value = villa.numLunch || 0;
        newData.costPerDinner.value = villa.costPerDinner || 0;
        newData.numDinner.value = villa.numDinner || 0;
        newData.costPerAlcohol.value = villa.costPerAlcohol || 0;
        newData.numAlcohol.value = villa.numAlcohol || 0;
        newData.costPerCoffee.value = villa.costPerCoffee || 0;
        newData.numCoffee.value = villa.numCoffee || 0;
        newData.roomRental.value = villa.roomRental || {value: 0, pp: "per day"};
        newData.av.value = villa.av || {value: 0, pp: "per day"};
        newData.setupFee.value = villa.setupFee || {value: 0, pp: "per day"};
        newData.numMeetings.value = villa.numMeetings || 0;
        newData.miscellaneousCosts.value = villa.miscellaneousCosts ? [...villa.miscellaneousCosts] : [];
        newData.notes = villa.notes || "";
        newData.distanceFromAirport.value = villa.distanceFromAirport || "";
        newData.numberOfBedrooms.value = villa.numberOfBedrooms || 0;
        newData.villaURL.value = villa.villaURL || "";
        newData.nearestCity.value = villa.nearestCity || "";
        newData.distanceToCity.value = villa.distanceToCity || "";

        setExpData(newData);
    }


    return (
        <React.Fragment>
             <RebelModal isOpen={savedModal} toggle={() => {setSavedModal(!savedModal)}}>
                <RebelModalHeader>Saved</RebelModalHeader>
                <RebelModalBody>
                Successfully saved to the experience guide database.
                </RebelModalBody>
                <RebelModalFooter>
                <RebelAccentButton onClick={() => {setSavedModal(!savedModal)}}>
                    Okay
                </RebelAccentButton>
                </RebelModalFooter>
            </RebelModal>
            <RebelModal isOpen={failedModal} toggle={() => setFailedModal(!failedModal)}>
                <RebelModalHeader>Error</RebelModalHeader>
                <RebelModalBody>
                    We encountered an error while trying to save your data. Please make sure all input fields are filled.
                </RebelModalBody>
                <RebelModalFooter>
                    <RebelAccentButton onClick={() => setFailedModal(!failedModal)}>
                        Okay
                    </RebelAccentButton>
                </RebelModalFooter>
            </RebelModal>
            <RebelModal isOpen={deleteModal} toggle={() => setDeleteModal(!deleteModal)}>
                <RebelModalHeader>
                    Delete Experience?
                </RebelModalHeader>
                <RebelModalBody>
                    Are you sure you would like to delete this experience? Once deleted, all experience data will be permanently lost.
                </RebelModalBody>
                <RebelModalFooter>
                    <RebelSecondaryButton onClick={() => setDeleteModal(!deleteModal)}>
                        Cancel
                    </RebelSecondaryButton>
                    <RebelDangerButton onClick={() => deleteExperience(deleteID)}>
                        Delete Experience
                    </RebelDangerButton>
                </RebelModalFooter>
            </RebelModal>
            <StyledContainer id="cost-output-container">
            {props.devMode && (
                <DevInfoPanel>
                    <DevInfoTitle>Experience Debug Info</DevInfoTitle>
                    <DevInfoRow>
                        <DevInfoLabel>Experience ID:</DevInfoLabel>
                        <DevInfoValue>{props.experience[0]}</DevInfoValue>
                    </DevInfoRow>
                    <DevInfoRow>
                        <DevInfoLabel>Property ID:</DevInfoLabel>
                        <DevInfoValue>{expData.villaId?.value || '(none selected)'}</DevInfoValue>
                    </DevInfoRow>
                    <DevInfoRow>
                        <DevInfoLabel>Property Name:</DevInfoLabel>
                        <DevInfoValue>{expData.villaName?.value || '(none)'}</DevInfoValue>
                    </DevInfoRow>
                </DevInfoPanel>
            )}
            {!props.client &&
            <React.Fragment>
                <Collapse isOpen={costInputOpen}>
                <Row>
                    <Col lg="3">
                        <RebelFormInput title="Select Property"
                                            id="villaId"
                                            data={expData}
                                            setData={(x) => {
                                                setExpData(x);
                                                handleVillaSelection(x.villaId.value);
                                            }}
                                            type="select"
                                            options={
                                                <>
                                                    <option value="">-- Select a Property --</option>
                                                    {villaList.map && villaList.map((villa) => (
                                                        <option key={villa.id} value={villa.id}>
                                                            {villa.villaName} - {villa.location}
                                                        </option>
                                                    ))}
                                                </>
                                            }/>
                    </Col>
                    <Col lg="2" style={{display:"flex", alignItems:"flex-end", paddingLeft:"0px"}}>
                        {expData.villaId.value && expData.villaURL?.value && (
                            <VillaURLLink
                                href={expData.villaURL.value.startsWith('http') ? expData.villaURL.value : `https://${expData.villaURL.value}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{marginBottom: "16px"}}>
                                View Property Listing →
                            </VillaURLLink>
                        )}
                    </Col>
                    <Col lg="2">
                        <RebelFormInputIndex title="Index"
                            id="index"
                            type="number"
                            data={expData}
                            value={expData.index ? expData.index : 0}
                            setData={(x) => setExpData(x)}/>
                    </Col>
                    <Col lg="5" style={{display:"flex", justifyContent:"flex-end", alignItems:"flex-end", gap:"10px"}}>
                        <RebelAccentButton style={{marginBottom: "16px", height:"46px"}} onClick={() => saveRetreatCosts()}>Save</RebelAccentButton>
                        <RebelDangerButton style={{marginBottom: "16px", height:"46px"}} onClick={() => confirmDelete(props.experience[1].id)}>Delete</RebelDangerButton>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <RebelFormInput title="R.E.B.E.L Experience Title"
                                            id="title" data={expData}
                                            setData={(x) => setExpData(x)}
                                            type="text"/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <RebelFormInput title="Location"
                                            id="location" data={expData}
                                            setData={(x) => setExpData(x)}
                                            type="text"/>
                    </Col>
                    <Col>
                    <RebelFormInput title="Destination Currency"
                                            id="destCurrency" data={expData}
                                            setData={(x) => setExpData(x)}
                                            type="select"
                                            dataSanitation={(newData, guideData) => removeConversionWhenSwitchingCurrency(newData, guideData)}
                                            dataSanitationParams={props.guideData}
                                            options={currencyOptions()}/>
                    </Col>
                    <Col>
                    {expData.destCurrency.value !== props.guideData.currency.value &&
                    <FormInputExchange title="Exchange Rate"
                                            baseid="base"
                                            convertid="convert"
                                            data={expData}
                                            setData={(x) => setExpData(x)}
                                            type="number"
                                            base={expData.base}
                                            convert={expData.convert}
                                            destCurrency={expData.destCurrency}
                                            clientCurrency={props.guideData.currency}
                                            options={currencyOptions()}/>
                    }

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <RebelFormInput title="Property Rental Fee"
                                                id="villaRentalFee" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Cleaning Fee"
                                                id="cleaningFee" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col xs="6">
                    </Col>
                </Row>
                {/*
                <Row>
                    <Col><BoldLabel style={{color: RebelColors.gold}}>General Costs Per Attendee</BoldLabel></Col>
                </Row>
                */}
                <Row id="first-section">
                    {/*
                    <Col>
                        <RebelFormInput title="Accommodation Cost"
                                                id="accommodationCost" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Single Rate"
                                                id="singleRate" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Single Rooms"
                                                id="singleRooms" data={expData}
                                                setData={(x) => setExpData(x)}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Double Rate"
                                                id="doubleRate" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Double Rooms"
                                                id="doubleRooms" data={expData}
                                                setData={(x) => setExpData(x)}
                                                type="number"/>
                    </Col>
                    */}
                    <Col xs="2">
                        <RebelFormInput title="Flight Cost"
                                                id="flightCost" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Cost Per Activity"
                                                id="costPerActivity" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col>
                        <RebelFormInput title="Number of Activities"
                                                id="numActivities" data={expData}
                                                setData={(x) => setExpData(x)}
                                                type="number"/>
                    </Col>
                    <Col>
                    <RebelFormInput title="Cost Per Transportation"
                                                id="costPerTransportation" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                    </Col>
                    <Col xs="4">
                        <RebelFormInputExperienceMulti title="Transportation Provided"
                                            id="transportation"
                                            data={expData}
                                            setData={(x) => setExpData(x)}
                                            options={transportationOptions}
                                            transportation={expData.transportation}/>

                    </Col>

                </Row>
                <Row>
                    <Col><BoldLabel style={{color: RebelColors.gold}}>Meal Costs Per Attendee</BoldLabel></Col>
                </Row>
                <Row id="meals-section">
                    <Col>
                        <Row>
                            <Col>
                            <RebelFormInput title="Cost Per Breakfast"
                                                id="costPerBreakfast" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                            <Col>
                            <RebelFormInput title="Cost Per Lunch"
                                                id="costPerLunch" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                            <Col>
                            <RebelFormInput title="Cost Per Dinner"
                                                id="costPerDinner" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                            <Col>
                            <RebelFormInput title="Cost Per Snack"
                                                id="costPerAlcohol" data={expData}
                                                setData={(x) => setExpData(x)}
                                                currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                type="number"/>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col><BoldLabel style={{color: RebelColors.gold}}>Meetings Costs</BoldLabel></Col>
                </Row>
                <Row id="meals-section">
                    <Col>
                        <Row>
                            <Col>
                                <RebelFormInputPP title="Room Rental"
                                                    id="roomRental" data={expData}
                                                    setData={(x) => setExpData(x)}
                                                    currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                    type="number"/>
                            </Col>
                            <Col>
                                <RebelFormInputPP title="Setup Fees"
                                                    id="setupFee" data={expData}
                                                    setData={(x) => setExpData(x)}
                                                    currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                    type="number"/>
                            </Col>

                        </Row>
                        <Row>
                            <Col lg="3">
                                <RebelFormInput title="Number of Meetings"
                                                    id="numMeetings" data={expData}
                                                    setData={(x) => setExpData(x)}
                                                    type="number"/>

                            </Col>
                            <Col lg="3">
                                <RebelFormInputPP title="AV"
                                                    id="av" data={expData}
                                                    setData={(x) => setExpData(x)}
                                                    currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                    type="number"/>

                            </Col>
                            <Col>
                                <RebelFormInput title="Cost Per Coffee"
                                                    id="costPerCoffee" data={expData}
                                                    setData={(x) => setExpData(x)}
                                                    currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                                    type="number"/>
                            </Col>
                            <Col>
                                <RebelFormInput title="Number of Coffees"
                                                    id="numCoffee" data={expData}
                                                    setData={(x) => setExpData(x)}
                                                    type="number"/>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col><BoldLabel style={{color: RebelColors.gold}}>Miscellaneous Costs</BoldLabel></Col>
                </Row>

                {expData.miscellaneousCosts.value !== undefined && refresh && (
                    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                        <SortableContext
                            items={expData.miscellaneousCosts.value.map(item => item.id)}
                            strategy={verticalListSortingStrategy}
                        >
                            {expData.miscellaneousCosts.value.map((obj, index) => (
                                <RebelSortableItem
                                    key={obj.id}
                                    id={obj.id}
                                    index={index}
                                    miscCost={[index, obj]}
                                    currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""}
                                    deleteMiscCost={deleteMiscCost}
                                    handleMiscellaneousChange={handleMiscellaneousChange}
                                />
                            ))}
                        </SortableContext>
                    </DndContext>
                )}

                {false && expData.miscellaneousCosts.value !== undefined && refresh && Object.entries(expData.miscellaneousCosts.value).map((miscCost, i) => {

                    if (miscCost !== undefined) {
                        return(
                            <RebelMiscellaneousInputs  key={i} miscCost={miscCost} currency={expData.destCurrency.value ? expData.destCurrency.value.slice(3): ""} deleteMiscCost={(x) => deleteMiscCost(x)} handleMiscellaneousChange={handleMiscellaneousChange} i={i}/>
                        )
                    }
                })}

                <Row>
                    <Col>
                        <StyledButton onClick={(x) => addMiscellaneousCost(x)}>Add miscellaneous cost</StyledButton>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <RebelFormInput
                            key="notes"
                            title="Notes"
                            id="notes" data={expData}
                            setData={(x) => setExpData(x)}
                            type="text"/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <RebelAccentButton style={{margin: "20px 0px"}} onClick={(x) => saveRetreatCosts(x)}>Save Retreat</RebelAccentButton>
                        {displaySummary && <RebelAccentButton style={{margin: "20px 0px 20px 15px"}} onClick={(x) => setDisplaySummary(!displaySummary)}>Hide Cost Summary</RebelAccentButton> }
                        {!displaySummary && <RebelAccentButton style={{margin: "20px 0px 20px 15px"}} onClick={(x) => setDisplaySummary(!displaySummary)}>Show Cost Summary</RebelAccentButton> }

                        {costInputOpen && <RebelUnderlineButton style={{margin: "20px 0px"}} onClick={(x) => setCostInputOpen(!costInputOpen)}>Hide retreat cost inputs</RebelUnderlineButton>}
                    </Col>
                </Row>

                <Spacer/>

                </Collapse>

                </React.Fragment>}
                {!costInputOpen && <RebelUnderlineButton style={{margin: "20px 0px"}} onClick={() => setCostInputOpen(!costInputOpen)}>Show retreat cost inputs</RebelUnderlineButton>}
                <Collapse isOpen={displaySummary}>
                    <CostSummary guideData={props.guideData}
                                expData={expData}/>
                </Collapse>


        </StyledContainer>
        </React.Fragment>
    )
}

export default RebelExperienceInputFormTab;

const StyledContainer = styled.div`
    margin-left: 1px;
    margin-right: 1px;
    padding: 15px;
    border-radius: 0px 0px 10px 10px;
    border: 2px solid ${RebelColors.gold}
`

const StyledButton = styled(Button)`
    background-color: ${RebelColors.gold};
    border: 0px;
    color: #000000;
    font-weight: 600;

    &:hover {
        background-color: #d4af37;
        color: #000000;
    }
`

const RebelUnderlineButton = styled(UnderlineButton)`
    color: ${RebelColors.text};

    &:hover {
        color: ${RebelColors.gold};
    }
`

const VillaURLLink = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    min-height: 46px;
    background-color: ${RebelColors.gold};
    color: #000000 !important;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    border-radius: 6px;
    transition: all 0.3s ease;
    border: none;
    white-space: nowrap;

    &:hover {
        background-color: #d4af37;
        color: #000000 !important;
        text-decoration: none;
    }

    &:active {
        transform: translateY(1px);
    }
`

const DevInfoPanel = styled.div`
    background-color: #1a1a2e;
    border: 1px solid #4a4a4a;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
    font-family: monospace;
`;

const DevInfoTitle = styled.div`
    color: #00d9ff;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const DevInfoRow = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
        margin-bottom: 0;
    }
`;

const DevInfoLabel = styled.span`
    color: #888;
    font-size: 12px;
    min-width: 120px;
`;

const DevInfoValue = styled.span`
    color: #00ff88;
    font-size: 12px;
    background-color: #0a0a15;
    padding: 4px 8px;
    border-radius: 4px;
    user-select: all;
`;
